/*
const myPath = new HeartTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  width: 300,
  height: 300,
});
console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
selectNode(myPath);
*/
class HeartTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = "HeartTextPath";

    this.width(config?.width ?? 300);
    this.height(config?.height ?? 300);
  }


  static getAttrNames() { return ['width', 'height']; }
  static getDefaultAttrs() { return { width: 300, height: 300 }; }


  width(v) {
    if (v === undefined) return this.attrs.width ?? 0;
    this.attrs.width = v;
    this.updatePath();
    return this;
  }


  height(v) {
    if (v === undefined) return this.attrs.height ?? 0;
    this.attrs.height = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(this.width(), this.height()));
  }


  generateSvgPath(width, height) {
    const kX = width / 200;
    const kY = height / 250;
    const path = `M${100 * kX},${50 * kY} C${150 * kX},${-10 * kY} ${200 * kX},${50 * kY} ${200 * kX},${100 * kY} C${200 * kX},${150 * kY} ${150 * kX},${200 * kY} ${100 * kX},${250 * kY} C${50 * kX},${200 * kY} 0,${150 * kY} 0,${100 * kY} C0,${50 * kY} ${50 * kX},${-10 * kY} ${100 * kX},${50 * kY} Z`;
    
    return path;
  }
}
